<script>
import VueCountdown from '@chenfengyuan/vue-countdown'
import moment from 'moment'
import SvgTimerCircle from '@src/components/svg-countdown-timer-circle.vue'
export default {
  components: {
    VueCountdown,
    SvgTimerCircle,
  },
  props: {
    height: {
      type: Number,
      required: true,
    },
    addLeftFade: {
      type: Boolean,
    },
  },
  data() {
    return {
      uuid: crypto.randomUUID(),
      timerStarted: false,
      circlesLoaded: false,
      daysProgress: 0,
      minutesProgress: 0,
      hoursProgress: 0,
      currentUTC: moment.utc().format('x'),
      targetUTC: 1713456000000,
    }
  },
  computed: {
    countdownTime() {
      return this.targetUTC - this.currentUTC > 0 ? this.targetUTC - this.currentUTC : 0
    },
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },

  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },

  methods: {
    openCvent() {
      window.open('https://cvent.me/Yy1DZY', '_blank')
    },
    measureToHeightRatio(desiredPixel) {
      const baseHeight = 400
      const ratio = baseHeight / desiredPixel
      return this.height / ratio
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible' && this.$refs.mileCountdown?.totalMilliseconds) {
        this.updateCountdown(this.$refs.mileCountdown)
      }
    },
    updateCountdown({ days, hours, minutes, seconds }) {
      if (minutes) {
        this.minutesProgress = Math.ceil((100 * minutes) / 60)
      }
      if (hours) {
        this.hoursProgress = Math.ceil((100 * hours) / 24)
      }
      if (days) {
        this.daysProgress = Math.ceil((100 * days) / 109)
      }
    },
  },
}
</script>

<template>
  <div v-if="countdownTime" :class="$style.mileContainer" @click="openCvent">
    <div class="w-100 h-100">
      <div v-if="addLeftFade" :class="$style.leftFade" />
      <VueCountdown
        ref="mileCountdown"
        emit-events
        :time="countdownTime"
        @progress="updateCountdown"
        @start="
          () => {
            timerStarted = true
          }
        ">
        <template v-slot="props">
          <div
            v-if="timerStarted"
            :style="{ 'margin-top': measureToHeightRatio(27) + 'px', 'margin-left': -measureToHeightRatio(-6) + 'px' }"
            :class="$style.circlesContainer">
            <div
              :style="{ width: measureToHeightRatio(270) + 'px', height: measureToHeightRatio(270) + 'px' }"
              class="position-relative">
              <SvgTimerCircle
                :base-height="height"
                :desired-height="270"
                :progress="daysProgress || Math.ceil((100 * props.days) / 109)" />
              <p
                :class="$style.circleText"
                :style="{ height: measureToHeightRatio(270) + 'px', 'font-size': height / 4 + 'px' }"
                >{{ props.days }}</p
              >
              <p
                :class="$style.circleLabel"
                :style="{ 'margin-top': -(height / 66.666) + 'px', 'font-size': height / 11.111 + 'px' }"
                >DAYS</p
              >
            </div>

            <div
              :style="{
                width: measureToHeightRatio(270) + 'px',
                height: measureToHeightRatio(270) + 'px',
                'margin-right': -measureToHeightRatio(20) + 'px',
                'margin-left': -measureToHeightRatio(20) + 'px',
              }"
              class="position-relative">
              <SvgTimerCircle
                :base-height="height"
                :desired-height="270"
                :progress="hoursProgress || Math.ceil((100 * props.hours) / 24)" />
              <p
                :class="$style.circleText"
                :style="{ height: measureToHeightRatio(270) + 'px', 'font-size': height / 4 + 'px' }"
                >{{ props.hours }}</p
              >
              <p
                :class="$style.circleLabel"
                :style="{ 'margin-top': -(height / 66.666) + 'px', 'font-size': height / 11.111 + 'px' }"
                >HOURS</p
              >
            </div>
            <div
              :style="{ width: measureToHeightRatio(270) + 'px', height: measureToHeightRatio(270) + 'px' }"
              class="position-relative">
              <SvgTimerCircle
                :base-height="height"
                :desired-height="270"
                :progress="minutesProgress || Math.ceil((100 * props.minutes) / 60)" />
              <p
                :class="$style.circleText"
                :style="{ height: measureToHeightRatio(270) + 'px', 'font-size': height / 4 + 'px' }"
                >{{ props.minutes }}</p
              ><p
                :class="$style.circleLabel"
                :style="{ 'margin-top': -(height / 66.666) + 'px', 'font-size': height / 11.111 + 'px' }"
                >MINUTES</p
              >
            </div>
          </div>
        </template>
      </VueCountdown>
    </div>
    <img
      :style="{ left: measureToHeightRatio(5) + 'px' }"
      :class="$style.citySkyline"
      src="@assets/images/milecountdown/CitySkyline.png"
      alt="" />
    <img :class="$style.guitarSilhouette" src="@assets/images/milecountdown/GuitarShape.png" alt="" />
    <img
      :style="{ right: height / 4 + 'px', width: height / 2.325581395348837 + 'px' }"
      :class="$style.guitarAustin"
      src="@assets/images/milecountdown/Guitar.jpg"
      alt="" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.mileContainer {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
  background: #007dc3;
}

.citySkyline {
  position: absolute;
  bottom: 0;
  width: 75%;
  filter: brightness(0) saturate(100%) invert(30%) sepia(93%) saturate(1175%) hue-rotate(179deg) brightness(88%)
    contrast(106%);
}

.guitarSilhouette {
  position: absolute;
  top: -32.3%;
  right: -15%;
  width: 45.85%;
}

.guitarAustin {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.circlesContainer {
  position: relative;
  z-index: 20;
  display: flex;
  justify-content: center;
  width: 74%;
  height: 100%;
}

.circleText {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-family: 'Gotham', serif;
  color: white;
}

.circleLabel {
  position: absolute;
  bottom: -15%;
  left: 50%;
  font-family: 'Gotham', serif;
  color: white;
  text-align: center;
  transform: translateX(-50%);
}

.circleCanvasContainer {
  display: flex;

  canvas {
    max-width: 100%;
    max-height: 100%;
  }
}

.leftFade {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 18px;
  height: 100%;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
}
</style>
